import { Trans } from '@lingui/react'
import { Link } from '@twisto/components/atoms/link'
import {
  Headline,
  HeadlineSubtitle,
  HeadlineTitle,
} from '@twisto/components/atoms/headline'
import { useAppConfig } from '@twisto/base'
import * as styles from './personal-id-step-headline.styles'

export const PersonalIdStepHeadline = () => {
  const baseConfig = useAppConfig()
  const { region } = baseConfig

  return (
    <Headline align="start" css={styles.headlineSection}>
      <HeadlineTitle>
        <Trans id="flow.personalIdStep.title" />
      </HeadlineTitle>
      <HeadlineSubtitle>
        <Trans id="flow.personalIdStep.subtitle" />
      </HeadlineSubtitle>
      {region === 'PL' && (
        <HeadlineSubtitle>
          <Trans
            components={[
              <Link key={0} href={'https://info.mobywatel.gov.pl/'}>
                {null}
              </Link>,
            ]}
            id="flow.personalIdStep.second.subtitle"
          />
        </HeadlineSubtitle>
      )}
    </Headline>
  )
}
